export class CardConfigs {
    setConfig(mainCardConfig, miniCardConfig) {
        this.mainConfig = mainCardConfig;
        this.miniConfig = miniCardConfig;
    }
    getConfig(isMini) {
        if (!this.miniConfig) {
            return this.mainConfig;
        }
        return isMini ? this.miniConfig : this.mainConfig;
    }
    getCardConfigBySportId(sportId, isMini) {
        const config = this.getConfig(isMini);
        return config[sportId] || config["0"];
    }
}
//# sourceMappingURL=CardConfig.js.map